import { investmentTransactionFormFactory } from 'app-components/forms/investment/investmentTransactionForm';
import { createFormHooks } from 'app-components/utils/createForm/formHooks';

export const { FormProvider, ...investmentTransactionEditFormHooks } = createFormHooks(
  investmentTransactionFormFactory,
);
